import React from "react";
import images from "components/images";
import styled from "styled-components";

const NotFound = ({ text = "Page not found." }) => (
  <ErrorBox>
    <img src={images["ErrorSymbol"]} alt={"error"} />
    {text}
  </ErrorBox>
);

const ErrorBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  place-content: center;
  flex-direction: column;
`;

export default NotFound;
